import React from 'react'
import "./style.css";
import ConnectWizard from './../../components/ConnectWizard';
import { useAccount, useDisconnect } from 'wagmi';
import MintBox from '../../components/Main';
import { useContract } from '../../contracts/api';
import { useState } from 'react';
import { useEffect } from 'react';
import { toast } from 'react-hot-toast';

export default function Home() {
  const { address } = useAccount();
  const [amount, setAmount] = useState(0);
  const contract = useContract();
  const { disconnect } = useDisconnect();

  const getAmount = async (_contract) => {
    if (!_contract || !address) return;

    const userBalance = await _contract.methods.balanceOf(address).call();

    if (userBalance / 10 ** 9 < 500000) {
      toast.error(`You're not authorized`);
      disconnect();
      return;
    }

    setAmount((userBalance / 10 ** 9).toFixed(2));
  }

  useEffect(() => {
    getAmount(contract);
  }, [contract, address])

  return (
    <div className='home-container'>
      {amount - 500000 >= 0 ? <MintBox amount={amount} /> : <ConnectWizard />}
    </div>
  )
}
